// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__mj4MT","breadcrumbs":"Breadcrumbs_breadcrumbs__JOOMj"};